import { getUser } from "@/components/session/JwtTokenManager";
import { FullMeeting } from "@/types/meetings";

export function isPendingBookingRequest({
  eventAt,
  isBookingRequest,
  canceledAt,
}: {
  eventAt?: string | null;
  isBookingRequest?: boolean | null;
  canceledAt?: string | null;
}): boolean {
  return !eventAt && !!isBookingRequest && !canceledAt;
}

export const couldManageAttendees = (meeting: FullMeeting): boolean => {
  const user = getUser();
  const organizer = meeting?.customer;
  const isOrganizer = user?.id === organizer?.id;
  if (
    isOrganizer ||
    user?.isSuperuser ||
    user?.isWorkspaceAgent ||
    user?.assistOnUserIds?.map((id) => `${id}`).includes(`${organizer?.id}`)
  ) {
    return true;
  }
  return false;
};
